import FiltersTabs from './FiltersTabs';

export default FiltersTabs;
